import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

const ExternalLoginForm = ({ onExternalLoginClicked, onCreateALoginClicked }) => {
  return (
    <div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <PrimaryButton type="button" onClick={onExternalLoginClicked}>
            Log In To Swims
          </PrimaryButton>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <SecondaryButton onClick={onCreateALoginClicked}>Create a Login</SecondaryButton>
        </div>
      </div>
    </div>
  );
};

export default ExternalLoginForm;